import { createClientMobileAppPromptController } from '~/utils/clientMobileAppPrompt';

const controller = createClientMobileAppPromptController({
   getItem: (key) => window.sessionStorage.getItem(key),
   setItem: (key, value) => window.sessionStorage.setItem(key, value),
   removeItem: (key) => window.sessionStorage.removeItem(key),
});

export function useClientMobileAppPrompt() {
   const state = shallowRef(controller.getSnapshot());
   const unsubscribe = controller.subscribe((snapshot) => {
      state.value = snapshot;
   });
   onScopeDispose(unsubscribe);
   return { state: readonly(state), ...controller };
}
